import actionTypes from '../actionTypes';


export function requestCreateClub({ name, description, avatar, code }) {
  return {
    type: actionTypes.CREATE_CLUB_REQUEST,
    name,
    description,
    avatar,
    code
  };
}
export function successCreateClub() {
  return {
    type: actionTypes.CREATE_CLUB_SUCCESS
  };
}
export function failCreateClub( data ) {
  return {
    type: actionTypes.CREATE_CLUB_FAILURE,
    createClubData: data
  };
}

export function requestJoinClub( {clubId, agentId} ) {
  return {
    type: actionTypes.JOIN_CLUB_REQUEST,
    clubId,
    agentId
  };
}
export function successJoinClub() {
  return {
    type: actionTypes.JOIN_CLUB_SUCCESS
  };
}

export function requestClubsInfo() {
  return {
    type: actionTypes.CLUBS_INFO_REQUEST
  };
}
export function successClubsInfo( clubsData ) {
  return {
    type: actionTypes.CLUBS_INFO_SUCCESS,
    clubsData
  };
}

export function requestClubList( clubsData ) {
  return {
    type: actionTypes.MAKE_CLUB_LIST,
    clubsData
  };
}
export function successClubList( clubsData ) {
  return {
    type: actionTypes.CLUBS_SUCCESS,
    clubsData
  };
}

export function requestCurrentClub( clubId ) {
  return {
    type: actionTypes.CURRENT_CLUB_REQUEST,
    clubId
  };
}

export function successCurrentClub( currentClub ) {
  return {
    type: actionTypes.CURRENT_CLUB_SUCCESS,
    currentClub
  };
}

export function requestCurrentClubMembers() {
  return {
    type: actionTypes.CURRENT_CLUB_MEMBERS_REQUEST
  };
}

export function successCurrentClubMembers( members ) {
  return {
    type: actionTypes.CURRENT_CLUB_MEMBERS_SUCCESS,
    members
  };
}

export function resetCurrentClub() {
  return {
    type: actionTypes.RESET_CURRENT_CLUB
  };
}

export function requestDisbandClub({ clubId, history }) {
  return {
    type: actionTypes.DISBAND_CLUB_REQUEST,
    clubId,
      history
  };
}

export function successDisbandClub() {
  return {
    type: actionTypes.DISBAND_CLUB_SUCCESS
  };
}

export function openLeagueMenu() {
  return {
    type: actionTypes.TOGGLE_LEAGUE_MENU,
  };
}

export function changeClubRequest(changes) {
  return {
    type: actionTypes.CHANGE_CLUB_REQUEST,
    changes
  };
}

export function changeClubSuccess({clubId, description}) {
  return {
    type: actionTypes.CHANGE_CLUB_SUCCESS,
    clubId,
    description
  };
}

export function changeClubFailure() {
  return {
    type: actionTypes.CHANGE_CLUB_FAILURE
  };
}

export function clubDataRequest(clubId, startDate, endDate, forAgent = false) {
    return {
        type: actionTypes.CLUB_DATA_REQUEST,
        clubId,
        startDate,
        endDate,
        forAgent,
    };
}

export function clubDataSuccess(clubId, data) {
    return {
        type: actionTypes.CLUB_DATA_SUCCESS,
        clubId,
        data,
    };
}

export function changeMemberRoleRequest(memberId, roleId) {
    return {
        type: actionTypes.CHANGE_MEMBER_ROLE_REQUEST,
        memberId,
        roleId,
    };
}

export function changeMemberRoleSuccess(memberId, roleId) {
    return {
        type: actionTypes.CHANGE_MEMBER_ROLE_SUCCESS,
        memberId,
        roleId,
    };
}

export function changeMemberRoleFailure() {
  return {
    type: actionTypes.CHANGE_MEMBER_ROLE_FAILURE,
  };
}

export function alterPokerFrame(clubId, params) {
  return {
    type: actionTypes.ALTER_POKER_FRAME,
      clubId,
      params,
  };
}

export function initPokerFrame(clubId) {
  return {
      type: actionTypes.INIT_POKER_FRAME,
      clubId,
  };
}

export function successClubProducts(prods, clubId) {
  return {
    type: actionTypes.CLUB_PRODUCTS_SUCCESS,
    prods,
    clubId
  };
}

export const exportDataRequest = (email, tradeRecord, from, to) => ({
  type: actionTypes.EXPORT_DATA_REQUEST,
  email,
  tradeRecord,
  from,
  to,
});

export const exportDataSuccess = () => ({
  type: actionTypes.EXPORT_DATA_SUCCESS,
});

export const exportDataFailure = (e) => ({
  type: actionTypes.EXPORT_DATA_FAILURE,
  exception: e,
});

export const leaveClub = () => ({
  type: actionTypes.LEAVE_CLUB,
});
